'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureMediaQueries = exports.renderServerCSS = exports.addKeyframes = exports.stylesToClasses = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _emotion = require('emotion');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stylesToClasses = exports.stylesToClasses = function stylesToClasses() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(styles).reduce(function (classNames, styleKey) {
    return _extends({}, classNames, _defineProperty({}, styleKey, (0, _emotion.css)(styles[styleKey])));
  }, {});
};

var addKeyframes = exports.addKeyframes = function addKeyframes() {
  var keyframes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(keyframes).reduce(function (keyframeNames, keyframeKey) {
    return _extends({}, keyframeNames, _defineProperty({}, keyframeKey, (0, _emotion.keyframes)(keyframes[keyframeKey])));
  }, {});
};

var renderServerCSS = exports.renderServerCSS = function renderServerCSS() {
  return console.log('Import renderServerCSS from constructicon/lib/renderDocument and wrap your server rendered HTML i.e. renderServerCSS(generatedHTMLString)');
};

var configureMediaQueries = exports.configureMediaQueries = function configureMediaQueries() {
  return console.log('No longer require configureMediaQueries');
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/lib/css/index.js
// module id = 843
// module chunks = 0